import space from '../namespace';
import { IState } from '../state';
import actionTypes, { ActionTypeValues } from '../actionTypes';
import namespace from '../namespace';

export type devicesActionType = {
  type: `${ActionTypeValues}`,
  namespace: `${namespace}`,
  payload: any,
  series: string;
};

const reducer = (
  state: IState,
  // action: IAction<
  //   Partial<IState[space.devices]> & {
  //     namespace?: `${space}`;
  //     resetKeys?: string[];
  //   }
  // >,
  action: devicesActionType,
): IState => {
  const { type, namespace = space.devices, payload, series } = action;

  switch (type) {
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICES_CHANNEL_LIST]: {
      const _state = state[namespace];
      const _series = (_state?.[series as keyof typeof _state] || {}) as any;
      return {
        ...state,
        [namespace]: {
          ..._state,
          [series]: {
            ..._series,
            channelList: payload,
          },
        },
      };
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICES_ARTICAL_LIST]: {
      const _state = state[namespace];
      const _series = (_state?.[series as keyof typeof _state] || {}) as any;
      return {
        ...state,
        [namespace]: {
          ..._state,
          [series]: {
            ..._series,
            articalList: { ...(_series?.articalList || {}), ...payload },
          },
        },
      };
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICES_CHANNEL_ACTIVE_KEYS]: {
      const _state = state[namespace];
      const _series = (_state?.[series as keyof typeof _state] || {}) as any;
      return {
        ...state,
        [namespace]: {
          ..._state,
          [series]: {
            ..._series,
            channelActiveKeys: payload,
          },
        },
      };
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICES_CHANNEL_SORT_KEY_MAP]: {
      const _state = state[namespace as space.devices];
      const _series = (_state?.[series as keyof typeof _state] || {});
      return {
        ...state,
        [namespace]: {
          ..._state,
          [series]: {
            ..._series,
            channelSortKeyMap: { ...(_series?.channelSortKeyMap || {}), ...payload },
          },
        },
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_DEVICES_SERIES_NAME]: {
      const _state = state[namespace];
      const _series = (_state?.[series as keyof typeof _state] || {}) as any;
      return {
        ...state,
        [namespace]: {
          ..._state,
          [series]: {
            ..._series,
            devicesSeriesName: payload,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
